<template>
  <div class="orcamentos-pendentes-retorno">
    <g-card class="card-orcamentos-pendentes-retorno" :expansivel="true" :comecaFechado="false">
      <template #cabecalho>
        <div class="header-filtros">
          <div class="titulo-filtros-cabecalho"> Orçamentos Pendentes de Retorno </div>
          <div class="header-icons">
            <g-button
            class="trash-box"
            tipo="cinza"
            altura="35px"
            largura="45px"
            icone="icone_lixo.svg"
            tamanhoIcone="15px"
            somenteIcone
            :sombreado="false"
            v-tooltip="'Limpar filtro'"
            @click="limparFiltro"
            />
            <g-button
              class="buscar-button-header-filtro"
              icone="icone_lupa.svg"
              negritoTexto
              largura="150px"
              altura="35px"
              tamanhoIcone="15px"
              tamanhoTexto="15px"
              gap="10px"
              :sombreado="false"
              @click="getOrcamentosByFiltro"
            >
              BUSCAR
            </g-button>
          </div>
        </div>
      </template>

      <g-form>
        <div class="pendentes-retorno-conteudo espacamento-filtros">
          <div class="unidade">
            <div class="unidade-titulo titulo-conteudo-filtros"> Unidade </div>
            <PDropDown
            class="unidade-input input-label"
            :filter="true"
            optionLabel="nome"
            optionValue="id"
            :options="empresaArray"
            placeholder="TODAS"
            v-model="objFiltro.EmpresaId"
            ></PDropDown>
          </div>

          <div class="cliente">
            <div class="cliente-titulo titulo-conteudo-filtros"> Cliente </div>
            <!-- <PDropDown
                class="codigo-ordenacao-input"
                :filter="true"
                :filterFields="['razaoSocial','codigoExterno','nomeFantasia','situacao','estadoCidade','cnpj']"
                placeholder="Selecione o cliente"
                optionLabel="nomeFantasia"
                optionValue="id"
                @filter="buscarClientes($event.value)"
                :options="clienteArray"
                v-model="objFiltro.ClientesIds"
            >
            <template #option="slotProps">
              <cliente-dropdown-item :dadosCliente="slotProps.option"></cliente-dropdown-item>
            </template>
          </PDropDown> -->
            <cliente-dropdown 
            class="cliente-input input-label"
            v-model="objFiltro.ClienteId"
            :empresaId="objFiltro.EmpresaId"
            :representanteId="this.$store.state.representanteSelecionadoId"
            />
          </div>

          <div class="numero-solicitacao">
            <div class="numero-solicitacao-titulo titulo-conteudo-filtros"> Número da Solicitação </div>
            <PInputText
            class="input-texto"
            placeholder="Insira o número da solicitação"
            v-model="objFiltro.NumeroSolicitacao"
            />
          </div>

          <div class="produto">
            <div class="produto-titulo titulo-conteudo-filtros"> Produto </div>
            <PDropDown
            class="nome-produto-input input-label"
            placeholder="Insira o nome do produto"
            :filter="true"
            @filter="getProduto($event.value)"
            :options="ProdutoArray"
            optionLabel="labelProduto"
            optionValue="produtoId"
            v-model="objFiltro.ProdutoId"
            />
          </div>

          <!-- <div class="periodo-baixa">
            <div class="periodo-baixa-titulo titulo-conteudo-filtros"> Período de Baixa </div>
            <div class="input-data">
              <div class="data-inicio">
                <g-date-input
                class="periodo-baixa-inicio-input input-label"
                placeholderinput="Início"
                alturainput="40px"
                largurainput="100%"
                tamanhobotao="35px"
                invertido
                :dataPassadas="true"
                v-model="objFiltro.PeriodoDeBaixaInicio"
                ></g-date-input>
              </div>
              <div class="data-periodo"> à </div>
              <div class="data-termino">
                <g-date-input
                class="periodo-baixa-termino-input input-label"
                placeholderinput="Término"
                alturainput="40px"
                largurainput="100%"
                tamanhobotao="35px"
                :dataPassadas="true"
                v-model="objFiltro.PeriodoDeBaixaFim"
                ></g-date-input>
              </div>
            </div>
          </div> -->

          <div class="periodo-emissao">
            <div class="periodo-emissao-titulo titulo-conteudo-filtros"> Período de Emissão </div>
            <div class="input-data">
              <div class="data-inicio">
                <g-date-input
                class="periodo-emissao-inicio-input input-label"
                placeholderinput="Início"
                alturainput="40px"
                largurainput="100%"
                tamanhobotao="35px"
                invertido
                :dataPassadas="true"
                v-model="objFiltro.PeriodoDeEmissaoInicio"
                ></g-date-input>
              </div>
              <div class="data-periodo"> à </div>
              <div class="data-termino">
                <g-date-input
                class="periodo-emissao-termino-input"
                placeholderinput="Término"
                alturainput="40px"
                largurainput="100%"
                tamanhobotao="35px"
                :dataPassadas="true"
                v-model="objFiltro.PeriodoDeEmissaoFim"
                ></g-date-input>
              </div>
            </div>
          </div>

          <div class="linha-producao">
            <div class="titulo-conteudo-filtros"> Pendentes a mais de </div>
            <PInputText
              class="input-texto"
              placeholder="Núm. de dias"
              v-model="objFiltro.QuantidadeDeDiasPendentes"
            />
            <!-- <div class="linha-producao-titulo titulo-conteudo-filtros"> Linha de Produção </div>
            <PDropDown
                class="linha-producao-input input-label"
                placeholder="Selecione"
                :filter="true"
                @filter="buscarLinhaProducao($event.value)"
                :options="LinhaProducaoArray"
                optionLabel="nomeLinha"
                optionValue="nomeLinha"
                v-on:blur="habilitarbotao"
                v-model="objFiltro.LinhaProducao"
            ></PDropDown> -->
          </div>

          <!-- <div class="filtro-status label-filtro">
            <div class="titulo-conteudo-filtros">Status</div>
            <PDropDown
                class="codigo-ordenacao-input"
                :filter="true"
                optionLabel="nomeCidade"
                placeholder="Selecione"
                v-model="objFiltro.Status"
            ></PDropDown>
          </div> -->

          <div class="tempo-pendencia">
            <!-- <div class="titulo-conteudo-filtros"> Pendentes a mais de </div>
            <PInputText
              class="input-texto"
              placeholder="Núm. de dias"
              v-model="objFiltro.QuantidadeDeDiasPendentes"
            /> -->
          </div>

          <!-- <div class="filtro-ordenacao label-filtro">
            <div class="titulo-conteudo-filtros">Ordenação</div>
            <PDropDown
                class="codigo-ordenacao-input"
                :filter="true"
                optionLabel="nomeCidade"
                placeholder="Selecione a ordenação"
                v-model="objFiltro.Ordenacao"
            ></PDropDown>
          </div> -->         
        </div>

        <div class="buscar-button-filtro">
          <g-button
          class="buscar-button"
          largura="300px"
          icone="icone_lupa.svg"
          negritoTexto
          tamanhoIcone="15px"
          tamanhoTexto="15px"
          altura="35px"
          gap="10px"
          :sombreado="false"
          @click="getOrcamentosByFiltro"
          >
            BUSCAR
          </g-button>
        </div>
      </g-form>
    </g-card>

    <g-card v-if="pt1" paddingDefault="1em 0 3em" :temCabecalho="false">
      <img class="icone-global-imagemfundo" src="@/assets/imgs/Ilustracao_erro.svg" />
      <div class="texto-padrao-imagemfundo">
        Verifique os filtros e clique em buscar para exibir os resultados
      </div>
    </g-card>

    <g-card v-else-if="!pt1" paddingDefault="0em 0 3em" :temCabecalho="false">
      <g-data-table
      TextoVazio="Nenhum orçamento Encontrado"
      Titulo="Dados do Cliente"
      altura="auto"
      :colunas="Colunas"
      :valores="orcamentoArray"
      :Paginacao="true"
      :NumeroLinhas="100"
      :FiltrosEspecificos="true"
      :Editavel="false"
      :GerarOrca="true"
      v-on:clickGerarOrca="GerarOrcaClick"
      v-on:duploClickLinha="direcionaDetalhes"
      :rowEditor="true"
      :campoAgrupador="'empresaRepresentanteCliente'"
      :campoExibicaoGrupo="'empresaRepresentanteCliente'"
      ></g-data-table>
    </g-card>

    <PDialog :showHeader="false" :closable="false" v-model:visible="popup" :modal="true">
      <div class="titulo-popup-finalizado popups-consultar-orcamentos"> Deseja criar um novo orçamento com as mesmas informações? </div>
      <div class="botoes-popup">
        <div>
          <g-button
          tipo="cinza"           
          negritoTexto
          largura="200px" 
          altura="35px" 
          @click="popup = false"
          >
            NÃO
          </g-button>
        </div>
        <div>
          <g-button
          negritoTexto
          largura="200px" 
          altura="35px" 
          @click="criarCopiaDeOrcamento"
          >
            SIM
          </g-button>
        </div>
      </div>
    </PDialog>

    <PDialog class="gama-popup" :closable="true" v-model:visible="popupMotivo">
      <template #header>
          <div class="titulo-formulario titulo-popup-motivo"> MOTIVO DE RETORNO </div>
      </template>

      <div class="conteudo-popup-motivo-baixa">
        <div class="numero-orcamento">
          <div class="titulo-popup-finalizado"> Orçamento #{{numeroOrcamento}} </div>
        </div>

        <div class="motivo">
          <div class="titulo"> Motivo </div>
          <PTextArea
            disabled
            rows="7"
            cols="80" 
            :autoResize="true"
            v-model="motivoRetorno"
          ></PTextArea>
        </div>
      </div>

      <div class="botoes-popup">
        <div>
          <g-button
          tipo="cinza"
          class="botao-cancelar"
          largura="200px"
          negritoTexto
          @click="popupMotivo = false"
          >
            CANCELAR
          </g-button>
        </div>
        <div>
          <g-button
          tipo="amarelo"
          class="botao-informar"
          largura="200px"
          negritoTexto
          @click="redireciona"
          >
            EDITAR ORÇAMENTO
          </g-button>
        </div>
      </div>
    </PDialog>
  </div>
</template>

<script>
import ConsultarOrcamentoPendente from "./ConsultarOrcamentoPendente.js";
export default ConsultarOrcamentoPendente;
</script>

<style scoped>
.titulo-popup-finalizado {
  font-size: 17px;
}

.titulo-popup-finalizado {
  padding: 25px 0 1px;
}

.botoes-popup {
  margin-top: 30px;
}

.titulo {
  color: #4F2C19;
  text-align: left;
  font-family: "MontSerrat";
  font-weight: 700;
  margin-top: 15px;
}

@media (min-width:310px) {

}

@media (min-width: 500px) {
.pendentes-retorno-conteudo {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(7, auto);
  grid-column-gap: 20px;
}

.unidade { grid-area: 1 / 1 / 2 / 3; }
.cliente { grid-area: 2 / 1 / 3 / 3; }
.numero-solicitacao { grid-area: 3 / 1 / 4 / 3; }
.produto { grid-area: 4 / 1 / 5 / 3; }
.periodo-baixa { grid-area: 5 / 1 / 6 / 3; }
.periodo-emissao { grid-area: 6 / 1 / 7 / 3; }
.linha-producao { grid-area: 7 / 1 / 8 / 2; }
.tempo-pendencia { grid-area: 7 / 2 / 8 / 3; }
}

@media (min-width: 600px) {
.pendentes-retorno-conteudo {
  grid-template-rows: repeat(4, auto);
}

.unidade { grid-area: 1 / 1 / 2 / 2; }
.cliente { grid-area: 1 / 2 / 2 / 3; }
.numero-solicitacao { grid-area: 2 / 1 / 3 / 2; }
.produto { grid-area: 2 / 2 / 3 / 3; }
.periodo-baixa { grid-area: 3 / 1 / 4 / 2; }
.periodo-emissao { grid-area: 3 / 1 / 4 / 2; }
.linha-producao { grid-area: 3 / 2 / 4 / 3; }
.tempo-pendencia { grid-area: 4 / 1 / 5 / 2; }
}

@media (min-width: 801px) {

}

@media (min-width: 1025px) {
.pendentes-retorno-conteudo {
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, auto);
}

.unidade { grid-area: 1 / 1 / 2 / 2; }
.cliente { grid-area: 1 / 2 / 2 / 3; }
.numero-solicitacao { grid-area: 1 / 3 / 2 / 4; }
.produto { grid-area: 2 / 1 / 3 / 2; }
.periodo-baixa { grid-area: 2 / 2 / 3 / 3; }
.periodo-emissao { grid-area: 2 / 2 / 3 / 3; }
.linha-producao { grid-area: 2 / 3 / 3 / 4; }
.tempo-pendencia { grid-area: 3 / 1 / 4 / 2; width: 60%; }
}

@media (min-width: 1281px) {

}

@media (min-width: 1400px) {
.pendentes-retorno-conteudo {
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, auto);
}

.unidade { grid-area: 1 / 1 / 2 / 2; }
.cliente { grid-area: 1 / 2 / 2 / 3; }
.numero-solicitacao { grid-area: 1 / 3 / 2 / 4; }
.produto { grid-area: 1 / 4 / 2 / 5; }
.periodo-baixa { grid-area: 2 / 1 / 3 / 2; }
.periodo-emissao { grid-area: 2 / 1 / 3 / 2; }
.linha-producao { grid-area: 2 / 2 / 3 / 3; }
.tempo-pendencia { grid-area: 2 / 3 / 3 / 4; }
}

</style>
